var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container margin-top-1 col-7 flex1",attrs:{"id":"not-found"}},[_c('div',{staticClass:"no-content-wrapper user-select"},[_c('i',{staticClass:"v-icon v-sad oops-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b537592","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NsfwWarning.vue
// module id = pnxY
// module chunks = 0